module.exports = __webpack_public_path__ + "static/media/upload-data-center.b8aedb2e.svg";